export const MediaType = {
  photo: 'photo',
  illustration: 'illustration',
  video: 'video',
  vector: 'vector',
};
